import ItemCard from "@affinity/components/ItemCard/ItemCard";
import { CardGridContainer } from "@affinity/components/ProductList/ProductListCardGrid";
import { Section } from "@affinity/components/Section";
import PlaceOrderInitialise from "@affinity/Handlers/PlaceOrderInitialise";
import PlaceOrderSetProduct from "@affinity/Handlers/PlaceOrderSetProduct";
import { BindPrePopulate, PlaceOrderQueryModel, PopulateDelegate } from "@affinity/Store/PrePopulation";
import { CustomState } from "@affinity/Store/Reducers";
import { AffinityProduct } from "@affinity/Store/StoreTypes";
import { getPageStateByType } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import Button from "@insite/mobius/Button";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const { value } = getPageStateByType(state, "AffinityPlaceOrderPage");
    const regularId = value?.fields.regularId;
    const premiumId = value?.fields.premiumId;
    const productRegular = state.affinity_place_order.productRegular;
    const productPremium = state.affinity_place_order.productPremium;
    const populateFunction = BindPrePopulate(state);

    // extract path URL
    // rebuild remaining URL with remaining segments...
    // move out to shared code...
    return {
        regularId,
        premiumId,
        productRegular: productRegular?.productTitle,
        productPremium: productPremium?.productTitle,
        formState: state.affinity_place_order,
        populateFunction,
    };
};

const mapDispatchToProps = {
    // Map loader and setter methods to component properties
    PlaceOrderInitialise,
    PlaceOrderSetProduct,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export const Step1SelectProduct: React.FC<Props> = ({
    PlaceOrderInitialise,
    premiumId,
    regularId,
    productRegular,
    productPremium,
    PlaceOrderSetProduct,
    history,
    populateFunction,
}) => {

    const popSetProduct: PopulateDelegate = function (data) {
        // Return if no data
        if (!data.product) {
            return undefined;
        }

        // Trim data for URL update
        const updatedQuery: PlaceOrderQueryModel = {
            ...data,
            product: undefined,
        }

        // Check known values
        switch (data.product?.toLowerCase()) {
            case "regular":
                PlaceOrderSetProduct({ selectedProduct: AffinityProduct.Regular });
                return updatedQuery;
            case "premium":
                PlaceOrderSetProduct({ selectedProduct: AffinityProduct.Premium });
                return updatedQuery;
            default:
                return undefined;
        }
    }

    if (regularId && premiumId && !productRegular && !productPremium) {
        PlaceOrderInitialise({
            productRegularId: regularId,
            productPremiumId: premiumId,
            onComplete: () => {
                const popResult = populateFunction(popSetProduct, history);
                if (popResult) {
                    return popResult;
                }
            }
        });
    }

    return (
        <Section title="1. Select fuel type">
            <LoadingOverlay
                spinnerProps={{
                    css: css`
                        margin-left: -20px;
                        margin-top: -20px;
                    `,
                }}
                loading={!productRegular || !productPremium}
            >
                <CardGridContainer>
                    <ItemCard.Container>
                        <ItemCard.Title>{productRegular}</ItemCard.Title>
                        <Button
                            variant="secondary"
                            sizeVariant="medium"
                            onClick={() => PlaceOrderSetProduct({ selectedProduct: AffinityProduct.Regular })}
                        >
                            Select
                        </Button>
                    </ItemCard.Container>
                    <ItemCard.Container>
                        <ItemCard.Title>{productPremium}</ItemCard.Title>
                        <Button
                            variant="secondary"
                            sizeVariant="medium"
                            onClick={() => PlaceOrderSetProduct({ selectedProduct: AffinityProduct.Premium })}
                        >
                            Select
                        </Button>
                    </ItemCard.Container>
                </CardGridContainer>
            </LoadingOverlay>
        </Section>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(Step1SelectProduct));
